import { render, staticRenderFns } from "./industry-news.vue?vue&type=template&id=3ff7ee0a&scoped=true&"
import script from "./industry-news.vue?vue&type=script&lang=js&"
export * from "./industry-news.vue?vue&type=script&lang=js&"
import style0 from "./industry-news.vue?vue&type=style&index=0&id=3ff7ee0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff7ee0a",
  null
  
)

export default component.exports